import { onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { useUserStore } from 'stores/receiver/account/user/user'

import { useChangeQuasarLocale } from 'composables/common/i18n/changeQuasarLocale'
import { useEventBus } from 'composables/common/useEventBus'

import type { LocalesCode } from 'src/i18n/locales'

export const useChangeLocale = () => {
  const { changeQuasarLocale } = useChangeQuasarLocale()

  const { locale } = useI18n({ useScope: 'global' })

  const changeLocale = async (loc: LocalesCode) => {
    const langIso = loc
    // Set Quasar locale
    await changeQuasarLocale(langIso)

    // Set i18n locale
    locale.value = langIso
  }

  const { bus } = useEventBus()

  const watchLocale = (onChange: (locale: LocalesCode) => void) => {
    bus.on('changeLocale', (loc) => {
      onChange(loc)
    })

    onUnmounted(() => {
      bus.off('changeLocale')
    })
  }

  const updateToUserLocale = async () => {
    const userStore = useUserStore()

    if (
      userStore.user &&
      locale.value !== userStore.user.preferences.language
    ) {
      await changeLocale(userStore.user.preferences.language)
    }
  }

  return {
    changeLocale,
    watchLocale,
    updateToUserLocale,
  }
}
